import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { fetchGetLkType, TGetLkTypeResponse } from '../../repositories/lk-type/v2/get-lk-type';
import { TUserRole } from '../../types/currentUser';
import { IConfig } from '@cian/config/shared';

interface IDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
}

export async function resolveUserRole({ httpApi, logger }: IDependencies): Promise<TUserRole> {
  try {
    const response = (await fetchGetLkType({
      httpApi,
    })) as TGetLkTypeResponse;

    if (response.statusCode === 200) {
      return response.response.lkType;
    }

    return null;
  } catch (err) {
    logger.error(err, {
      message: err.message,
      stack: err.stack,
      comment: 'Ошибка запроса в get-lk-type',
    });

    return null;
  }
}
